/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MediaVersionDtoFromJSON, MediaVersionDtoToJSON, } from './MediaVersionDto';
import { VirusScanStatusFromJSON, VirusScanStatusToJSON, } from './VirusScanStatus';
/**
 * Check if a given object implements the MediaVersionsResponse interface.
 */
export function instanceOfMediaVersionsResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function MediaVersionsResponseFromJSON(json) {
    return MediaVersionsResponseFromJSONTyped(json, false);
}
export function MediaVersionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userFileId': !exists(json, 'userFileId') ? undefined : json['userFileId'],
        'virusScanStatus': !exists(json, 'virusScanStatus') ? undefined : VirusScanStatusFromJSON(json['virusScanStatus']),
        'versions': !exists(json, 'versions') ? undefined : (json['versions'] === null ? null : json['versions'].map(MediaVersionDtoFromJSON)),
    };
}
export function MediaVersionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userFileId': value.userFileId,
        'virusScanStatus': VirusScanStatusToJSON(value.virusScanStatus),
        'versions': value.versions === undefined ? undefined : (value.versions === null ? null : value.versions.map(MediaVersionDtoToJSON)),
    };
}
